const drivers = {
  drivers: 'Drivers',
  createNew: 'New',

  headerButtons: {
    create: {
      createBtn: 'Create',
    },

    import: 'Import',
  },

  import: {
    title: 'Drivers Upload',
  },

  toast: {
    error: {
      badResponse: '[Driver] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  table: {
    headers: {
      displayName: 'Name',
      name: 'Name',
      driverStatus: 'Status',
      email: 'Email',
      vehicle: 'Vehicle',
      phoneNumber: 'Phone number',
      address: 'Address',
      firstTripDistance: '1st Trip Max Distance',
      action: 'Action',
      attributes: 'Attributes',
      locations: 'Locations',
      areas: 'Zones',
      excludedProfiles: 'Excluded Profiles',
    },
    statusOptions: {
      online: 'Online',
      offline: 'Offline',
      break: 'Break',
      enRoute: 'En-Route',
      suspended: 'Suspended',
    },
    viewOptions: {
      showSuspended: 'Show Suspended',
      showUnsuspended: 'Show Unsuspended',
    },
    filters: {
      status: 'Status',
      vehicles: 'Vehicles',
      services: 'Services',
      suppliers: 'Suppliers',
      attributes: 'Attributes',
      areas: 'Zones',
      locations: 'Locations',
      airportLocations: 'Airport Locations',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  create: {
    submit: {
      success: 'Driver has been successfully created',
      error: 'Could not create driver due to an internal server error',
    },
  },

  update: {
    submit: {
      success: 'Driver has been successfully updated',
      error: 'Could not update driver due to an internal server error',
    },
    formTabs: {
      informationTab: 'Information',
      notesTab: 'Notes',
      historyTab: 'History',
      reservationPreferencesTab: 'Reservation Preferences',
    },
    toast: {
      toastResetSuccess: 'Reset Password email has been sent successfully.',
      toastError: 'Something went wrong, please try again.',
      toastRemoveDriverSuccess: 'Driver deleted successfully',
    },
    driverStatusOptions: {
      activate: 'Unsuspend',
      deactivate: 'Suspend',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      statusOffline: 'Offline',
      statusOnline: 'Online',
      statusEnRoute: 'En-Route',
      statusBreak: 'Break',
      popUpOptions: {
        popupTitleActive: 'Suspend Driver',
        popupTitleDeactivation: 'Unsuspend Driver',
        popupTitleUnsuspend: 'Unsuspend Reason',
        popupSubTitleDeactivation: 'Select the reason for the suspenssion',
        popupActionActive: 'Unsuspend Driver',
        popupActionDeactivate: 'Suspend Driver',
      },
    },
    modalRemoveConfirm: {
      header: 'Warning!',
      body: 'Are you sure you want to delete this driver?',
      confirmBtn: 'Delete',
    },
  },
  deleteModal: {
    header: 'Delete Drivers',
    body: 'You are about to delete {{num}} drivers.',
    success: 'Drivers were successfully deleted',
  },

  forms: {
    header: {
      createDriver: {
        title: 'Create',
      },

      updateDriver: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      personalDetails: {
        header: 'Personal Details',
        fields: {
          firstName: 'First Name',
          lastName: 'Last Name',
          name: 'Display Name',
          phone: 'Phone Number',
          email: 'Email Address',
          password: 'Password',
        },
      },

      areaSettings: {
        header: 'Zone Settings',
        fields: {
          areas: 'Zones',
          mode: 'Mode',
          priority: 'Priority',
          modeOptions: {
            allStops: 'All Stops',
            firstPickDrop: 'First PickUp / Last Drop-off',
            legAOrigin: 'Leg A Origin',
          },
          priorityOptions: {
            low: 'Low',
            medium: 'Medium',
            high: 'High',
            strict: 'Strict',
          },
        },
        locationsSettings: {
          header: 'Configuraciones de Ubicaciones',
          fields: {
            locations: 'Ubicaciones',
            enableInBetweenRides: 'Habilitar Viajes Intermedios',
          },
        },
      },

      locationsSettings: {
        header: 'Locations Settings',
        fields: {
          locations: 'Locations',
          enableInBetweenRides: 'Enable In-Between Rides',
        },
      },

      vehicles: {
        header: 'Assigned Vehicles',
        fields: {
          available: 'Available Vehicles',
          current: 'Current Vehicle',
        },
      },
      address: {
        header: 'Starting Address',
        fields: {
          mainAddress: 'Main Address',
          firstTripDistance: '1st Trip Max Distance',
          alt: 'Alternative Address',
        },
      },
      settings: {
        header: 'Additional Settings',
        fields: {
          services: 'Services',
          areas: 'Zones',
          externalId: 'External ID',
          ignoreDropoffTime: 'Ignore Drop-Off Time',
          ignoreDropoffTimeOptions: {
            bySystemSettings: 'By System Settings',
            enabled: 'Enabled',
            disabled: 'Disabled',
          },
          shiftBuffer: 'Shift Buffer',
        },
      },
      supplier: {
        header: 'Suppliers',
        fields: {
          suppliers: 'Suppliers',
        },
      },
      allowSharedRides: {
        header: 'Allow Shared Rides',
        fields: {
          allowSharedRides: 'Allow Shared Rides',
        },
      },
      attributes: {
        header: 'Attributes',
      },
      excludedProfiles: {
        header: 'Excluded Profiles',
        dualList: {
          profilesList: {
            header: 'Profile List',
          },
          excludedList: {
            header: 'Excluded Profiles',
          },
        },
      },
      buttons: {
        btnResetPassword: 'Reset Password',
        btnDelete: 'Delete',
      },
    },
  },
};

export default drivers;
